import moment from 'moment';

export const ovulationColumns = [
  {
    dataField: "Serial",
    text: "S.No",
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "createdAt",
    text: "Date of finding",
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "approxOvulation",
    text: "Approx. Ovulation",
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "fertileWindow",
    text: "Fertile Window",
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "nextPeriodStart",
    text: "Next Period Start",
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "avgCycleLength",
    text: "Monthly Average Cycle Length",
    align: "center"
  }
]

export const kickColumns = [
  {
    dataField: "Serial",
    text: "S.No",
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "date",
    text: "Start",
    formatter: (cell) => moment(cell).format("HH:mm"),
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "duration",
    text: "Duration",
    align: "center",
    headerAlign: "center"
  }, {
    dataField: "kicks",
    text: "Kicks",
    align: "center",
    headerAlign: "center"
  }
]


// WEBPACK FOOTER //
// ./src/views/HealthTools/Columns.js